import * as React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateField } from '@mui/x-date-pickers/DateField';
import { InputLabel } from '@mui/material';
import dayjs from 'dayjs';

type Props = {
  value: string;
  onDateSelect: (value:any) => void
}

export default function BasicDateField({value ,onDateSelect}:Props) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateField label={<InputLabel required>{'Date of Birth'}</InputLabel>} fullWidth value={value?dayjs(value):null} name="dob" onChange={(newValue) => onDateSelect(newValue)}/>
    </LocalizationProvider>
  );
} 